import { concat, includes, insert, pickAll, without } from 'ramda'

export const handleDataLayerEvent = id => {
  window.dataLayer.push({
    event: `search-filter-${id}`
  })
}

export const disableBedrooms = (housing_types = [], unit_types = []) => {
  return (
    housing_types.length === 0 &&
    unit_types.length === 1 &&
    unit_types.includes('SINGLE')
  )
}

export const updatePropertyFilters = (
  id,
  bedroom_count,
  housing_types,
  unit_types,
  updateFilters
) => {
  let filter = { bedroom_count, housing_types, unit_types }
  if (includes(id, ['SINGLE', 'PARTIAL', 'ENTIRE'])) {
    // Handle adding/removing unit type
    filter.unit_types = filter?.unit_types?.includes(id)
      ? without([id], filter.unit_types)
      : insert(0, id, filter.unit_types)
  } else {
    if (filter?.housing_types?.includes(id)) {
      // Handle removing housing type
      filter.housing_types = without([id], filter.housing_types)
    } else {
      // Handle adding housing type
      filter.housing_types = insert(0, id, filter.housing_types)
      // Add "ENTIRE" and "PARTIAL" to unit types when a housing type is added
      if (filter.housing_types.length > 0) {
        if (
          !filter.unit_types.includes('ENTIRE') &&
          !filter.unit_types.includes('PARTIAL')
        ) {
          filter.unit_types = concat(['ENTIRE', 'PARTIAL'], filter.unit_types)
        }
      }
    }
  }

  // Clean up unit types when no housing type is selected
  if (filter.housing_types.length === 0) {
    filter.unit_types = without(['ENTIRE', 'PARTIAL'], filter.unit_types)
  }

  // If no housing or unit type, set both to an empty array
  if (filter.housing_types.length === 0 && filter.unit_types.length === 0) {
    filter.housing_types = []
    filter.unit_types = []
  }

  // Clear bedroom_count when only "SINGLE" unit type is selected
  if (disableBedrooms(filter.housing_types, filter.unit_types)) {
    filter.bedroom_count = []
  }

  updateFilters(filter)
}

export const getFilterValues = filters =>
  pickAll(
    [
      'housing_types',
      'unit_types',
      'bedroom_count',
      'bathroom_count',
      'pet_policy',
      'min_price',
      'max_price',
      'availability_date',
      'custom_availability_date',
      'search_only_verified',
      'sort',
      'min_size',
      'lease_type',
      'rental_type',
      'has_3d_tour',
      'features',
      'utilities',
      'distance',
      'transportation'
    ],
    filters
  )
